import React from 'react'
import styles from './Forms.module.sass'
import {useWeb3App} from "../../../core/appContext";
import {defaultScan} from "../../../config";
import {BtnLoader} from "./Stake";


export function Unstake({ balances }) {
    const ghApp = useWeb3App()
    const [amount, setAmount] = React.useState('')
    const [step, setStep] = React.useState({ name: 'stake', status: 'start' })
    const [tx, setTx] = React.useState("")
    const [err, setErr] = React.useState()
    const handleUnstake = () => {
        setErr(null)
        setTx("")

        ghApp.unstakeCnr(amount).catch(err => {
            setStep({ name: 'unstake', status: 'error', message: "Transaction failed" })
        })
        ghApp.on('unstake:send', _tx => {
            setTx(_tx)
            setStep({ name: 'unstake', status: 'pending' })
        })
        ghApp.on('unstake:error', err => {
            setErr(err.message)
            setStep({ name: 'unstake', status: 'error' })
        })
        ghApp.on('unstake:receipt', _tx => {
            setTx(_tx)
            setStep({ name: 'unstake', status: 'done' })
            setAmount("")
            ghApp.emit('tx:success')
        })
    }

    return (
        <div className={styles.form}>
            <div className={styles.wrap}>
                <div className={styles.body}>
                    <div className={styles.title}>Unstake</div>
                    <div className={styles.title_desc}>My Staked CNR</div>
                    <div className={styles.clickable}>
                        <span className={styles.amount} onClick={() => setAmount(balances?.myStakedCNR)}>{balances?.myStakedCNR} </span>
                        <span className={styles.amount_cur}>CNR</span>
                    </div>
                    <input
                        className={styles.input}
                        type="number"
                        placeholder="Amount to unstake"
                        value={amount}
                        onChange={e => setAmount(e.target.value)}
                    />
                    {err && (<p className={styles.tx_desc}>{err}</p>)}
                    {tx && (<div>
                        <a href={`${defaultScan}/tx/${tx}`} className={styles.link} target="_blank" rel="noreferrer">
                            Transaction link
                        </a>
                    </div>)}
                </div>
                <div className={styles.footer}>
                    <button
                        onClick={handleUnstake}
                        disabled={amount == 0 || (step.name === 'unstake' && step.status === 'pending')}
                        className={styles.alone_btn}
                    >
                        <BtnLoader step={step} target={{ name: 'unstake', status: 'pending' }} />
                        <span>Unstake</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
